"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
/* eslint-disable jsx-a11y/alt-text */
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
require("react-image-crop/dist/ReactCrop.css");
var LightboxImage_1 = __importDefault(require("../LightboxImage"));
exports.useStyles = styles_1.makeStyles(function () { return ({
    image: {
        width: '100%',
    },
}); });
var ContentImage = function (_a) {
    var id = _a.id, cropped = _a.cropped, crop = _a.crop, className = _a.className, _b = _a.dimensions, dimensionsProp = _b === void 0 ? { height: 0, width: 0 } : _b, lightbox = _a.lightbox, other = __rest(_a, ["id", "cropped", "crop", "className", "dimensions", "lightbox"]);
    var classes = exports.useStyles();
    var _c = __read(react_1.useState(dimensionsProp), 2), dimensions = _c[0], setDimensions = _c[1];
    var _d = __read(react_1.useState(new Image()), 1), image = _d[0];
    var src = process.env.REACT_APP_IMGIX_URL + "/" + id + "?w=1200";
    react_1.useEffect(function () {
        image.src = src;
    }, [image.src, src]);
    image.onload = function () {
        if (dimensions.height === 0) {
            setDimensions({
                height: image.height,
                width: image.width,
                aspectRatio: image.width / image.height || 1,
            });
        }
    };
    if (cropped && crop) {
        src += "&rect=" + Math.round((crop.x / 100) * dimensions.width) + "," + Math.round((crop.y / 100) * dimensions.height) + "," + Math.round(dimensions.width * (crop.width / 100)) + "," + Math.round(dimensions.height * (crop.height / 100));
        // aspectRatio = Math.round(dimensions.width * (crop.width / 100)) / Math.round(dimensions.height * (crop.height / 100));
    }
    if (lightbox) {
        return react_1.default.createElement(LightboxImage_1.default, __assign({ src: src }, other, { alt: "" }));
    }
    return react_1.default.createElement("img", __assign({ className: className || classes.image, src: src }, other));
};
exports.default = ContentImage;
//# sourceMappingURL=Image.js.map